import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba120080"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'hd-base-tabs',
			`hd-base-tabs--${_ctx.modifier}`
		])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: _normalizeClass(["hd-base-tabs__item", { 'is-active': item === _ctx.itemActive }]),
        onClick: ($event: any) => (_ctx.setItemActive(item))
      }, [
        _createVNode(_component_lyra_asset, {
          "asset-key": `tab-item-${_ctx.getKebabCaseId(item)}`
        }, null, 8, ["asset-key"])
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}